import React, { useState } from 'react';
import { Plus, Pencil, Trash2 } from "lucide-react";
import { useDepartments } from '../../../contexts/DepartmentContext';
import DepartmentModal from './DepartmentModal';

function DepartmentManagementPage() {
  const { departments, removeDepartment, loading } = useDepartments();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentDepartment, setCurrentDepartment] = useState(null);

  const handleAddEdit = (department = null) => {    
    setCurrentDepartment(department);
    setIsModalOpen(true);
  };

  const handleDelete = async (departmentId) => {
    if (window.confirm("Are you sure you want to delete this department?")) {
      await removeDepartment(departmentId);
    }
  };

  if (loading) {
    return (
      <div className="p-4">
        <div className="animate-pulse space-y-4">
          <div className="h-6 bg-gray-300 rounded"></div>
          <div className="h-6 bg-gray-300 rounded"></div>
          <div className="h-6 bg-gray-300 rounded"></div>
        </div>
      </div>
    );
  }

  return (
    <div className='mt-4'>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-xl md:text-3xl font-oswald font-light">Department Management</h1>
        <button onClick={() => handleAddEdit()} className="btn btn-primary">
          <Plus className="w-4 h-4" />
          Add Department
        </button>
      </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
        <div className="stats shadow">
          <div className="stat">
            <div className="stat-title">Total Departments</div>
            <div className="stat-value">{departments.length}</div>
          </div>
        </div>
      </div>

      {/* Department Table */}
      <div className="overflow-x-auto bg-base-100 rounded-lg shadow">
        <table className="table w-full">
          <thead>
            <tr>
              <th>Name</th>
              <th>Faculty</th>
              <th className="w-20">Actions</th>
            </tr>
          </thead>
          <tbody>
            {departments.map((deparment) => (
              <tr key={deparment.id}>
                <td>{deparment.name}</td>
                <td>{deparment.faculty_detail.name}</td>
                <td className="flex gap-2">
                  <button
                    onClick={() => handleAddEdit(deparment)}
                    className="btn btn-square btn-sm btn-ghost"
                    title="Edit deparment"
                  >
                    <Pencil className="w-4 h-4" />
                  </button>
                  <button
                    onClick={() => handleDelete(deparment.id)}
                    className="btn btn-square btn-sm btn-ghost text-error"
                    title="Delete university"
                  >
                    <Trash2 className="w-4 h-4" />
                  </button>
                </td>
              </tr>
            ))}
            {departments.length === 0 && (
              <tr>
                <td colSpan="4" className="text-center py-4">
                  No Department found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Add/Edit Modal */}
      <DepartmentModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        currentDepartment={currentDepartment}
      />
    </div>
  );
}

export default DepartmentManagementPage;